import i18n from 'Lib/i18n'

export const PRODUCTS_OPTIONS = [
  {
    label: i18n.t('paid_marketing', { ns: 'domainManagement' }),
    value: 'paidMarketing',
    key: 'paidMarketingAllowed',
    limitKey: 'paidMarketingDomainsLimit',
    isDisabled: false,
  },
  {
    label: i18n.t('bot_zapping', { ns: 'domainManagement' }),
    value: 'botZapping',
    key: 'botZappingAllowed',
    limitKey: 'botZappingDomainsLimit',
    isDisabled: false,
  },
]
